<template>
  <div class="tabListContainer">
    <ul class="tabList">
      <li v-for="(tab, index) in sortedTabs"
          v-bind:item="tab"
          v-bind:index="index"
          v-bind:key="tab.Sequence">
        <header class="tabHeader" v-bind:class="{ active: isActive(tab), inactive: !isActive(tab) }" v-on:click.capture="setTab(tab, index)">{{tab.Title}}</header>
      </li>
    </ul>
    <section class="tabContents" v-bind:class="{ activeContent: isActive(activeTab), inactiveContent: !isActive(activeTab) }">
      <div class="tabContentContainer" v-if="activeTab !== null">
        <div v-html="activeTab.Content"></div>
        <br />
        <div v-for="(comp, cindex) in activeTab.Components"
             v-bind:item="comp"
             v-bind:index="cindex"
             v-bind:key="cindex">
          <component v-bind:is="comp"></component>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { DisplayTab } from '@/components/TabbedDisplay/DisplayTab.js'
export default {
  name: 'TabbedDisplay',
  data () {
    return {
      currentTab: null
    }
  },
  computed: {
    activeTab: function () {
      if (this.currentTab !== null && this.currentTab !== undefined) return this.currentTab
      if (this.tabs.length <= 0) return null
      this.setTab(this.tabs[0], 0)
      return this.tabs[0]
    },
    sortedTabs: function () {
      let sTabs = this.tabs.slice(0)
      sTabs.sort(this.sort)
      return sTabs
    },
    tabWidth: function () {
      let width = 100
      if (this.tabs.length <= 0) return width + '%'
      return width / this.tabs.length + '%'
    }
  },
  methods: {
    addTab (name, title, sequence, content, comps) {
      this.tabs.push(new DisplayTab(name, title, sequence, content, comps))
    },
    isActive (testTab) {
      if (testTab === null || testTab === undefined) return false
      var at = this.activeTab
      return testTab.Sequence === at.Sequence
    },
    setTab (item, index) {
      this.currentTab = item
      console.log(index)
      console.log(item)
    },
    sort (a, b) {
      if (a === null || a === undefined) return -1
      if (b === null || b === undefined) return 1
      return a.Sequence - b.Sequence
    }
  },
  props: ['tabs', 'width']
}
</script>
<style scoped>
  ul.tabList {
    display: inline-block;
    list-style-type: none;
    text-align: left;
    border-collapse: collapse;
    /*border-radius: 25px;*/
    padding: 0;
    margin: 0;
    width: 100%;
    vertical-align: top;
    border-bottom: 1px solid #000;
  }

    ul.tabList li {
      display: inline-block;
      vertical-align: top;
      text-align: left;
      border-left: 1px solid #000;
      border-right: 1px solid #000;
      border-bottom: 2px solid #000;
      border-top: 2px solid #000;
      padding: 0;
      margin: 0;
    }

  .tabHeader {
    font-weight: bold;
    font-size: 0.75em;
    font-variant: small-caps;
    text-align: left;
    cursor: pointer;
    padding: 0.25em;
  }

  .tabContents {
    background-color: transparent;
    color: #000;
  }
  .tabContentContainer {
    border-left: 1px solid #000;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
    border-collapse: collapse;
    padding: 0.5em;
  }

  .active {
    background-color: #fff;
    color: #000;
  }

  .inactive {
    background-color: #888;
    color: #eee;
  }

  .activeContent {
    display: contents;
  }

  .inactiveContent {
    display: none;
  }
</style>
